const e = () => ".grecaptcha-badge{display: none !important;}";
export {
  e as generateGoogleReCaptchaHiddenBadgeStyles
};
//# sourceMappingURL=generateGoogleReCaptchaHiddenBadgeStyles.js.map
